import { render, staticRenderFns } from "./NavGestion.vue?vue&type=template&id=24c0a2f2&scoped=true&"
import script from "./NavGestion.vue?vue&type=script&lang=js&"
export * from "./NavGestion.vue?vue&type=script&lang=js&"
import style0 from "./NavGestion.vue?vue&type=style&index=0&id=24c0a2f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c0a2f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAppBar,VImg})
